<template>
	<div class="paramset_pmode">
		<table>
			<tr>
				<td class="td1"><label>口 岸 别 名</label></td>
				<td class="td2"><el-input type="text" size="mini" v-model="p_mode_newname"></el-input></td>
				<td class="td3"><label>验证身份证</label></td>
				<td class="td4">
					<el-select size="mini" v-model="idcardcheck">
						<el-option v-for="item in yzidcardoption" :key="item.d_name" :label="item.d_name" :value="item.d_name"></el-option>
					</el-select>
				</td>
			</tr>
			<tr>
				<td class="td1"><label>同收件人个数</label></td>
				<td class="td2"><el-input type="number" size="mini" v-model="repeatcgcount"></el-input></td>
				<td class="td3" colspan="2"><el-switch on-value="1" size="mini" off-value="0" v-model="nofeeout"></el-switch><label> 未收费不允许出库</label></td>
			</tr>
			<tr>
				<td class="td1"><label>相似地址个数</label></td>
				<td class="td2"><el-input type="number" size="mini" v-model="repeataddrcount"></el-input></td>
				<td class="td3" colspan="2"><el-switch on-value="1" size="mini" off-value="0" v-model="setctaddr"></el-switch><label> 分配寄件地址</label></td>
			</tr>
			<tr>
				<td class="td1"><label>重 量 差 额</label></td>
				<td class="td2"><el-input type="number" size="mini" v-model="weightrange"></el-input></td>
				<td class="td3" colspan="2"><label class="graytips">( 当订单重量与称重重量的差额超过此差额时不允许出库 )</label></td>
			</tr>
			<tr>
				<td colspan="4">
					<label class="setaddresstips">特别注意 <br /></label>
					<label class="setaddresstips1">开启【分配寄件地址】参数后，出库操作仅允许在一台电脑上操作，多台操作有可能会分配到重复地址</label>
				</td>
			</tr>
		</table>
		<div class="bottom">
			<el-button size="mini" type="success" @click.native="SaveStorageOutParam">保存</el-button>
			<el-button size="mini" type="info" plain @click.native="dialogclose">关闭</el-button>
		</div>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	props: {
		pmode: {
			type: String,
			default:''
		}
	},
	data() {
		return {
			p_mode:'',
			p_mode_newname: '',//关口别名
			nofeeout:false,
			repeatcgcount: 1,
			idcardcheck:'',
			repeataddrcount: 0,
			setctaddr:false,
			postfix: '',
			sernumber: '',
			yzidcardoption: [],
			paramlist:[],
			rulelist:[],
			weightrange:''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/wm/paramset_pmode.scss');
		});
		this.p_mode=this.pmode;
		this.GetStorageOutParam();
	},
	methods: {
		dialogclose() {
			Utils.$emit('dialogclose', { close: '1' });
		},
		init(param){
			this.p_mode=param.p_mode;
			this.GetStorageOutParam();
		},
		//获取验证身份证选项
		getyzidcardoption(){
			var that=this;
			if(that.yzidcardoption.length==0){
				this.$apipost.get.dic({type:'验证身份证'}).then(res => {
					if (res.data != '') {
						that.yzidcardoption = res.data.list;
						if (res.data.list.length > 0) {
							if(that.idcardcheck==''){
								that.idcardcheck=res.data.list[0].d_name;
							}
						}
					}
				});
			}
		},
		//获取参数
		GetStorageOutParam(){
			var that=this;
			that.p_mode_newname='';//关口别名
			that.nofeeout=false;
			that.repeatcgcount=1;
			that.idcardcheck='';
			that.repeataddrcount= 0;
			that.setctaddr=false;
			that.postfix= '';
			that.sernumber= '';
			that.paramlist=[];
			that.rulelist=[];
			that.weightrange='';
			this.$apipost.get.GetStorageOutParam({p_mode:this.p_mode}).then(res => {
				if(res.param!=undefined){
					that.paramlist=res.param;
					res.param.forEach(e=>{
						if(e.p_showname=='别名')
							that.p_mode_newname=e.u_value;
						else if(e.p_showname=='验证身份证'){
							that.idcardcheck=e.u_value;
							that.getyzidcardoption();
						}
						else if(e.p_showname=='同收件人个数')
							that.repeatcgcount=e.u_value;
						else if(e.p_showname=='相似地址个数')
							that.repeataddrcount=e.u_value;
						else if(e.p_showname=='未收费不允许出库'){
							if(e.u_enabled=='True')
								that.nofeeout=true;
						}
						else if(e.p_showname=='分配寄件地址'){
							if(e.u_enabled=='True')
								that.setctaddr=true;
						}
						else if(e.p_showname=='重量差额'){
							that.weightrange=e.u_value;
						}
					});
				}
				// if(res.rule!=undefined){
				// 	that.rulelist=res.rule;
				// 	if(that.rulelist.length>0){
				// 		for(var i=0;i<that.rulelist.length;i++){
				// 			if(that.rulelist[i].r_type=='自定义字符'){
				// 				that.postfix=that.rulelist[i].r_value;
				// 			}
				// 			else if(that.rulelist[i].r_type=='流水号'){
				// 				that.sernumber=that.rulelist[i].r_value;
				// 			}
				// 		}
				// 	}
				// }
			});
		},
		//保存参数设置
		SaveStorageOutParam(){
			var that=this;
			var paramlist = new Array();
			var rulelist = new Array();
			if(that.p_mode_newname.trim()==''){
				this.$tool.message('请输入渠道别名', 0);
				return false;
			}
			else
			{
				var param = new Object();
				param.p_showname = "别名";
				param.u_value = that.p_mode_newname.trim();
				paramlist.push(param);
			}
			if(that.repeatcgcount==''){
				this.$tool.message('请输入同收件人个数', 0);
				return false;
			}
			else
			{
				var param = new Object();
				param.p_showname = "同收件人个数";
				param.u_value = that.repeatcgcount.trim();
				paramlist.push(param);
			}
			if(that.repeataddrcount==''){
				this.$tool.message('请输入相似地址个数', 0);
				return false;
			}
			else
			{
				var param = new Object();
				param.p_showname = "相似地址个数";
				param.u_value = that.repeataddrcount.trim();
				paramlist.push(param);
			}
			var param = new Object();
			param.p_showname = "验证身份证";
			param.u_value = that.idcardcheck;
			paramlist.push(param);
			
			var fee = new Object();
			fee.p_showname = "未收费不允许出库";
			fee.u_enabled =that.nofeeout?1:0;
			paramlist.push(fee);
			
			var setctaddress = new Object();
			setctaddress.p_showname = "分配寄件地址";
			setctaddress.u_enabled =that.setctaddr?1:0;
			paramlist.push(setctaddress);
			
			if (that.weightrange!=''){
				var weightrange = new Object();
				weightrange.p_showname = "重量差额";
				weightrange.u_value = that.weightrange;
				paramlist.push(weightrange);
			}
			// var rule = new Object();
			// rule.r_type = "自定义字符";
			// rule.r_value =that.postfix.trim();
			// rulelist.push(rule);
			// if(that.sernumber.trim()==''){
			// 	this.$tool.message('请输入批次号规则流水号', 0);
			// 	return false;
			// }
			// else{
			// 	var rule1 = new Object();
			// 	rule1.r_type = "流水号";
			// 	rule1.r_value =that.sernumber.trim();
			// 	rulelist.push(rule1);
			// 
			//,rulelist:JSON.stringify(rulelist)}
			this.$tool.loading('正在保存', 'paramset_pmode');
			this.$apipost.post.SaveStorageOutParam({p_mode:this.p_mode, paramlist:JSON.stringify(paramlist),rulelist:[]}).then(res => {
				this.$tool.loadingclose();
				if(res.state==1){
					this.$tool.message('保存成功', 1);
					that.dialogclose();
				}else{
					this.$tool.message('保存失败', 0);
				}
			});
		}
	}
};
</script>
